module.exports = __webpack_public_path__ + "media/images/icons/icon_baseball-1505e175538745ccdd293a63f070dfd6.png";